import { whatCanYouDo, WhatCanYouDoKeys } from '@teinor/erp/permissions';
import { UserPermissions } from '../CreateRoutering/types';

export const permissionCheck = (userPermissions: UserPermissions | false, permission: WhatCanYouDoKeys) => {
    if (userPermissions && userPermissions.n >= whatCanYouDo[permission]) {
        return true
    }
    return false
}